// extracted by mini-css-extract-plugin
export default {"bg-primary-dark":"Tab_bg-primary-dark__2fBW9","bg-primary-light":"Tab_bg-primary-light__6nGme","root":"Tab_root__Mwa3m","active":"Tab_active__IBmUc"};